module.exports = __webpack_public_path__ + "static/media/connectionsIcon.a095a1fd.svg";